import React, { useState, useEffect, useRef } from "react";
import { deleteSession, getUserInfoFromToken } from "../../utils/session";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import Cookies from "js-cookie";
import logo from "../../assets/zoneship icon.png";
import Sidebar from "../../components/Sidebar";
import ZoneShipLogo from "../../assets/zoneship text.png"; // adjust path as needed
import grouplogo from "../../assets/zoneship icon remove bg.png"; // adjust path as needed
import BulkUploadPopup from "../../Order/BulkUploadPopup"
import { FaPlus } from "react-icons/fa";


import {
  FiPlusSquare,
  FiUploadCloud,
  FiEdit,
  FiZap
} from "react-icons/fi";
import { MdOutlineCalculate } from "react-icons/md";
import { FaTicketAlt } from "react-icons/fa";
import AddCase from "../Support/AddCase";
import { Notification } from "../../Notification"



const Navbar = () => {
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [userData, setUserData] = useState();
  const [balance, setBalance] = useState();
  const [holdAmount, setHoldAmount] = useState();
  const [isAdminTab, setIsAdminTab] = useState(false);
  const [awbNumber, setAwbNumber] = useState("");
  const [imagePreview, setImagePreview] = useState("");
  const dropdownRef = useRef(null);
  const mobileMenuRef = useRef(null);
  const [showActions, setShowActions] = useState(false);
  const quickDropdownRef = useRef(null);
  const [showModal, setShowModal] = useState(false);
  const [upload, setUpload] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [employeeAccess, setEmployeeAccess] = useState({
    canCreate: false,
    canFeedbackView: false,
    canManageTickets: false,
  });
  const [rotation, setRotation] = useState(0);
  const [isBalanceDropdownOpen, setIsBalanceDropdownOpen] = useState(false);
  // const dropdownRef = useRef(null);


  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const [showEmployeeAuthModal, setShowEmployeeAuthModal] = useState(false);
  // Handle outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (quickDropdownRef.current && !quickDropdownRef.current.contains(event.target)) {
        setShowActions(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  const handleTrack = () => {
    if (awbNumber.trim() !== "") {
      navigate(`/dashboard/order/tracking/${awbNumber.trim()}`);
    }
  };

  const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const userInfo = getUserInfoFromToken();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = Cookies.get("session");
        if (!token) return;

        if (userInfo?.type === "user") {
          const response = await axios.get(
            `${REACT_APP_BACKEND_URL}/user/getUserDetails`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );
          if (response.data.user) {
            console.log("response data", response.data)
            setImagePreview(response.data.user.profileImage)
            setUserData(response.data.user);
            setBalance(response.data.user.Wallet?.balance || 0);
            setHoldAmount(response.data.user.Wallet?.holdAmount || 0);
            setIsAdminTab(response.data.user.adminTab);
            setRefresh(false)
          }
        } else if (userInfo?.type === "employee") {
          const response = await axios.get(
            `${REACT_APP_BACKEND_URL}/staffRole/verify`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );
          if (response.data.employee) {
            setUserData(response.data.employee);
            setBalance(response.data.employee.Wallet?.balance || 0);
            setIsAdminTab(response.data.employee.adminTab);
            setRefresh(false)
          }
        }
      } catch (err) {
        // Don't redirect here, let App.js handle session expiration
      }
    };

    fetchData();
  }, [refresh]);



  useEffect(() => {
    const handleScroll = () => {
      setIsDropdownOpen(false);
      setIsMobileMenuOpen(false);
    };

    const handleClickOutside = (event) => {
      // 👇 ignore clicks on profile icon FIRST
      if (event.target.closest(".profile-icon")) return;

      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setIsDropdownOpen(false);
      }

      if (
        mobileMenuRef.current &&
        !mobileMenuRef.current.contains(event.target)
      ) {
        setIsMobileMenuOpen(false);
      }
    };


    window.addEventListener("scroll", handleScroll);
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  const handleLogout = () => {
    deleteSession();

    // navigate("/login");
    window.location.href = "/login";
  };

  const handleRechargeWallet = () => {
    navigate("/dashboard/rechargeWallet");
  };

  const handleToggleAdmin = async (value) => {
    try {
      const token = Cookies.get("session");
      if (!token) return;

      await axios.post(
        `${REACT_APP_BACKEND_URL}/user/getUserDetails`,
        {
          adminTab: value,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      localStorage.removeItem("activeNdrTab"); // or whatever your token key is
      localStorage.removeItem("activeOrderTab");
      localStorage.removeItem("activeOperationFirstMileTab");
      localStorage.removeItem("activeOperationMidMileTab");
      localStorage.removeItem("activeOperationLastMileTab");
      localStorage.removeItem("activeUserDiscrepancyTab");
      localStorage.removeItem("activeDiscrepancyTab");
      localStorage.removeItem("activeSidebarItem");
      setIsAdminTab(value);

      // Redirect with full page reload
      if (value) {
        window.location.href = "/adminDashboard";
      } else {
        window.location.href = "/";
      }
    } catch (err) {
      console.error("Failed to toggle admin tab:", err);
    }
  };

  const handleNewOrderClick = async () => {
    try {

      const token = Cookies.get("session");

      const response = await axios.get(
        `${REACT_APP_BACKEND_URL}/users/getUsers`,
        {
          headers: { authorization: `Bearer ${token}` },
        }
      );

      if (response.data.isSeller) {
        navigate("/dashboard/order/neworder");
      } else {
        setShowModal(true);
      }
    } catch (error) {
      console.error("Error fetching sellers:", error);
    }
  };

  const handleBulkUpload = () => {
    setUpload(true);
  };

  const handleCalculateRate = () => {
    navigate("/dashboard/tools/Cost_Estimation")
  }
  let isSidebarAdmin = false;
  const handleCreateTicket = () => {

    setIsModalOpen(true);

  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setIsBalanceDropdownOpen(false);
      }
    }
    if (isBalanceDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isBalanceDropdownOpen]);


  return (
    <div className="pb-[60px]">
      {/* Navbar */}
      <div className="w-full bg-white shadow fixed top-0 left-0 right-0 z-50">
        <div className="flex items-center justify-between px-6 py-3">
          {/* Left Side: Sidebar Toggle (Hidden in Mobile) */}
          <div className="flex items-center justify-center">
            <button className="text-[12px] hidden lg:block lg:ml-0 text-[#632C9D]">
              <img
                src={grouplogo}
                alt="description"
                className="h-7 w-7 rounded-full"
              />
            </button>
          </div>

          {/* Logo - Centered in Mobile, Default in Laptop */}
          <div className="flex-1 flex justify-start lg:justify-start sm:ml-4 ml-8">
            <img src={ZoneShipLogo} alt="Logo" className="h-9" />
          </div>


          {/* Right Side: Three-dot menu in Mobile, Full menu in Desktop */}
          <div className="lg:hidden flex gap-4">
            <div className="relative">
              <div
                className={`flex items-center justify-center space-x-2 px-2 h-[30px] rounded-lg shadow-md w-fit border ${balance < 0 ? "border-red-500 bg-red-50" : "border-[#632C9D] bg-white"
                  }`}
              >
                <i
                  className={`fa-solid fa-wallet ${balance < 0 ? "text-red-500" : "text-[#632C9D]"
                    } text-[12px]`}
                  title="Wallet Info"
                ></i>

                <span
                  className={`text-[12px] font-[600] leading-none flex items-center space-x-1 select-none cursor-pointer ${balance < 0 ? "text-red-500" : "text-[#632C9D]"
                    }`}
                  onClick={() => setIsBalanceDropdownOpen((prev) => !prev)}
                >
                  <span>₹{balance?.toFixed(2)}</span>
                  <i
                    className={`fa-solid fa-caret-down text-[12px] transition-transform ${isBalanceDropdownOpen ? "rotate-180" : "rotate-0"
                      } ${balance < 0 ? "text-red-500" : "text-[#632C9D]"}`}
                  ></i>
                </span>

                <div
                  className={`w-4 h-4 rounded-full flex justify-center items-center ${balance < 0 ? "bg-red-500" : "bg-[#632C9D]"
                    }`}
                >
                  <FaPlus
                    className="text-[12px] font-[600] w-2 h-2 text-white cursor-pointer hover:text-gray-100 transition-transform duration-500"
                    title="Recharge wallet"
                    onClick={handleRechargeWallet}
                  />
                </div>

                <i
                  className={`fa-solid fa-sync-alt text-[12px] cursor-pointer hover:text-gray-500 transition-transform duration-500 ${balance < 0 ? "text-red-500" : "text-[#632C9D]"
                    }`}
                  title="Refresh balance"
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent dropdown toggle
                    setRotation((prev) => prev + 360);
                    setRefresh(true);
                    Notification("Wallet Refresh Successfully", "success");
                  }}
                  style={{ transform: `rotate(${rotation}deg)` }}
                ></i>
              </div>

              {isBalanceDropdownOpen && (
                <div
                  className="absolute right-0 mt-1 w-32 bg-white rounded-lg shadow-lg p-3 z-50"
                  style={{ minWidth: "9rem" }}
                >
                  <div className="flex text-[10px] gap-1">
                    <p className="text-gray-700 font-[600] mb-1">Balance :</p>
                    <p className={`${balance < 0 ? "text-red-500" : ""}`}>
                      ₹{balance?.toFixed(2) || "0.00"}
                    </p>
                  </div>

                  <div className="flex text-[10px] gap-1">
                    <p className="text-red-700 font-[600] mb-1">Hold Amount :</p>
                    <p>₹{holdAmount?.toFixed(2) || "0.00"}</p>
                  </div>
                </div>
              )}
            </div>

            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
              <i className="fas fa-ellipsis-v text-xl text-[#632C9D]"></i>
            </button>
          </div>




          <div className="hidden lg:flex items-center space-x-4">
            {/* AWB Search Bar */}
            <div className="flex items-center">
              <div className="flex items-center border border-gray-300 rounded-l-lg w-[180px] h-[30px] focus-within:border-[#632C9D] overflow-hidden">
                <input
                  type="text"
                  placeholder="Enter AWB Number"
                  className="px-2 text-[12px] border-none focus:outline-none placeholder:text-[12px] h-full w-full"
                  value={awbNumber}
                  onChange={(e) => setAwbNumber(e.target.value)}
                />
              </div>

              <button
                onClick={handleTrack}
                className="h-[30px] w-[46px] bg-[#632C9D] text-white text-[12px] font-[600] border border-[#632C9D] rounded-r-lg hover:bg-purple-500 transition"
              >
                Track
              </button>
            </div>


            {/* Divider */}
            <hr className="w-0 h-6 border-l border-gray-500" />

            <div className="relative inline-block text-left" ref={quickDropdownRef}>
              {/* Toggle Button */}
              <button
                onClick={() => setShowActions(!showActions)}
                className={`flex text-gray-500 items-center gap-1 px-3 h-[30px] rounded-lg border border-[#632C9D] hover:shadow-md text-[12px] font-[600] ${showActions ? "bg-white" : "bg-transparent"
                  }`}
              >
                <FiZap className="text-[#632C9D]" />
                Quick Actions
              </button>

              {/* Dropdown Actions */}
              {showActions && (
                <div className="absolute left-1/2 -translate-x-1/2 mt-3 z-50 bg-white border border-gray-200 rounded-lg shadow-lg px-4 py-3 w-[600px]">
                  {/* Arrow */}
                  <div className="absolute -top-2 left-1/2 transform -translate-x-1/2 w-3 h-3 bg-white rotate-45 border-l border-t border-gray-200"></div>

                  {/* Action Grid */}
                  <div className="grid grid-cols-4 gap-2">
                    <div
                      onClick={() => {
                        handleNewOrderClick();
                        setShowActions(false);
                      }}
                      className="flex flex-col items-center justify-center bg-gray-50 rounded-lg py-4 cursor-pointer hover:bg-gray-100 transition"
                    >
                      <div className="bg-purple-100 p-2 rounded-full text-[#632C9D] text-xl">
                        <FiPlusSquare />
                      </div>
                      <span className="text-[12px] font-[600] text-gray-700 mt-2 text-center">Add an Order</span>
                    </div>

                    <div
                      onClick={() => {
                        handleBulkUpload();
                        setShowActions(false);
                      }}
                      className="flex flex-col items-center justify-center bg-gray-50 rounded-lg py-4 cursor-pointer hover:bg-gray-100 transition"
                    >
                      <div className="bg-purple-100 p-2 rounded-full text-[#632C9D] text-xl">
                        <FiUploadCloud />
                      </div>
                      <span className="text-[12px] font-[600] text-gray-700 mt-2 text-center">Bulk Import</span>
                    </div>

                    <div
                      onClick={() => { setShowActions(false); handleCalculateRate(); }}
                      className="flex flex-col items-center justify-center bg-gray-50 rounded-lg py-4 cursor-pointer hover:bg-gray-100 transition"
                    >
                      <div className="bg-purple-100 p-2 rounded-full text-[#632C9D] text-xl">
                        <MdOutlineCalculate />
                      </div>
                      <span className="text-[12px] font-[600] text-gray-700 mt-2 text-center">Calculate Rate</span>
                    </div>

                    <div
                      onClick={() => { setShowActions(false); handleCreateTicket(); }}
                      className="flex flex-col items-center justify-center bg-gray-50 rounded-lg py-4 cursor-pointer hover:bg-gray-100 transition"
                    >
                      <div className="bg-purple-100 p-2 rounded-full text-[#632C9D] text-xl">
                        <FaTicketAlt />
                      </div>
                      <span className="text-[12px] font-[600] text-gray-700 mt-2 text-center">Create a Ticket</span>
                    </div>
                  </div>
                </div>
              )}
            </div>


            {/* Divider */}
            <hr className="w-0 h-6 border-l border-gray-500" />

            {/* Wallet Info */}
            <div className="flex items-center space-x-2">
              {/* Wallet info group */}
              <div
                className={`flex items-center justify-center space-x-2 px-3 h-[30px] rounded-lg shadow-md w-fit 
      ${balance < 0 ? "bg-red-500" : "bg-[#632C9D]"}`}
              >
                <div className="relative group flex items-center">
                  <i
                    onClick={handleRechargeWallet}
                    className={`fa-solid fa-wallet text-[12px] cursor-pointer 
          ${balance < 0 ? "text-white" : "text-white"}`}
                  ></i>

                  {/* Tooltip */}
                  <div className="absolute top-full left-1/2 ml-12 transform -translate-x-1/2 mt-4 w-max bg-white text-gray-700 text-[12px] font-[600] rounded-lg shadow-md px-3 py-2 space-y-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-50">
                    <div
                      className={`${balance < 0 ? "text-red-500 font-[700]" : "text-gray-700"}`}
                    >
                      Balance: ₹{balance?.toFixed(2) || "0.00"}
                    </div>
                    <div className="text-red-700">
                      Hold Amount: ₹{holdAmount?.toFixed(2) || "0.00"}
                    </div>
                  </div>
                </div>

                <span
                  className={`mt-[1px] text-[12px] font-[600] leading-none 
        ${balance < 0 ? "text-white" : "text-white"}`}
                >
                  ₹{balance?.toFixed(2)}
                </span>

                {/* Plus (Recharge) Icon */}
                <div
                  className={`w-4 h-4 rounded-full flex justify-center items-center 
        ${balance < 0 ? "bg-white" : "bg-white"}`}
                >
                  <FaPlus
                    className={`text-[12px] font-[600] w-3 h-3 cursor-pointer transition-transform duration-500 
          ${balance < 0 ? "text-red-500 hover:text-red-400" : "text-[#632C9D] hover:text-purple-500"}`}
                    title="Recharge wallet"
                    onClick={handleRechargeWallet}
                  />
                </div>
              </div>

              {/* Separate refresh button */}
              <button
                type="button"
                className={`h-[30px] w-[30px] flex items-center justify-center rounded-lg shadow-md border border-white transition
      ${balance < 0 ? "bg-red-500 hover:bg-red-600" : "bg-[#632C9D] hover:bg-purple-500"}`}
                title="Refresh balance"
                onClick={() => {
                  setRotation((prev) => prev + 360);
                  setRefresh(true);
                  Notification("Wallet Refresh Successfully", "success");
                }}
              >
                <i
                  className={`fa-solid fa-sync-alt text-[12px] transition-transform duration-500 
        ${balance < 0 ? "text-white" : "text-white"}`}
                  style={{ transform: `rotate(${rotation}deg)` }}
                />
              </button>
            </div>




            {/* Divider */}
            {/* <hr className="w-0 h-6 border-l border-gray-500" /> */}

            {/* Recharge Wallet Button */}
            {/* <button
              onClick={handleRechargeWallet}
              className="bg-[#632C9D] text-white font-[600] text-[12px] px-4 py-1.5 rounded-lg hover:bg-[#0aa66d] transition"
            >
              Recharge Wallet
            </button> */}

            {/* Divider */}
            {/* <hr className="w-0 h-6 border-l border-gray-500" /> */}

            {/* User Initial */}
            <div
              className="profile-icon w-8 h-8 bg-[#632C9D] text-white flex items-center justify-center rounded-full font-[600] cursor-pointer overflow-hidden"
              onClick={(e) => {
                e.stopPropagation(); // ✅ Prevent triggering the outside click handler
                setIsDropdownOpen((prev) => !prev);
              }}
            >
              {imagePreview ? (
                <img
                  src={imagePreview}
                  alt="profile"
                  className="w-full h-full rounded-full object-cover"
                />
              ) : (
                <span>
                  {userData?.email?.charAt(0).toUpperCase() || "U"}
                </span>
              )}
            </div>


          </div>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div ref={mobileMenuRef} className="fixed top-[62px] right-2 z-50 bg-white shadow-lg rounded-lg p-4 w-44">
          <ul className="space-y-4 text-[12px]">
            <li>
              <Link
                to="/dashboard/settings/company-profile"
                className="text-gray-700"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Profile
              </Link>
            </li>
            {/* <li
              className="flex items-center space-x-1"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              <i className="fa-solid fa-wallet text-gray-700"></i>
              <span className="text-gray-700 font-[600]">
                ₹{balance?.toFixed(2)}
              </span>
            </li> */}
            <li>
              <button
                onClick={() => {
                  handleRechargeWallet();
                  setIsMobileMenuOpen(false);
                }}
                className="text-gray-700"
              >
                Recharge Wallet
              </button>
            </li>
            {userData?.isAdmin && (
              <li className="flex items-center justify-between">
                <span className="text-gray-700 text-[12px]">
                  {isAdminTab ? "Admin" : "User"}
                </span>
                <label className="relative inline-flex items-center w-11 h-6 cursor-pointer">
                  <input
                    type="checkbox"
                    className="sr-only peer"
                    checked={isAdminTab}
                    onChange={(e) => handleToggleAdmin(e.target.checked)}
                  />
                  <div className="w-11 h-6 bg-gray-300 rounded-full peer peer-focus:outline-none peer-checked:bg-[#632C9D] transition-colors duration-300"></div>
                  <div className="absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition-transform duration-300 transform peer-checked:translate-x-5"></div>
                </label>
              </li>
            )}

            <li>
              <button
                className="text-red-600 hover:text-red-800"
                onClick={() => {
                  handleLogout();
                  setIsMobileMenuOpen(false);
                }}
              >
                Logout
              </button>
            </li>
          </ul>
        </div>
      )}

      {/* Profile Dropdown - Fixed Position, Hidden on Scroll */}
      {isDropdownOpen && (
        <div ref={dropdownRef} className="fixed top-[66px] text-[12px] font-[600] right-2 z-50 bg-white shadow-lg rounded-lg p-2 w-40">
          <ul className="">
            <li className="hover:bg-purple-100 p-2">
              <Link
                to="/dashboard/settings/company-profile"
                className="text-gray-700"
                onClick={() => setIsDropdownOpen(false)}
              >
                Profile
              </Link>
            </li>
            {userData?.isAdmin && (
              <li className="flex items-center justify-between hover:bg-purple-100 p-2">
                <span className="text-gray-700 text-[12px] font-[600]">
                  {isAdminTab ? "Admin" : "User"}
                </span>
                <label className="relative inline-flex items-center w-11 h-6 cursor-pointer">
                  <input
                    type="checkbox"
                    className="sr-only peer"
                    checked={isAdminTab}
                    onChange={(e) => handleToggleAdmin(e.target.checked)}
                  />
                  <div className="w-11 h-6 bg-gray-300 rounded-full peer peer-focus:outline-none peer-checked:bg-[#632C9D] transition-colors duration-300"></div>
                  <div className="absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition-transform duration-300 transform peer-checked:translate-x-5"></div>
                </label>
              </li>
            )}

            <li className="hover:bg-red-100 p-2">
              <button
                className="text-red-600 hover:text-red-800"
                onClick={() => {
                  handleLogout();
                  setIsDropdownOpen(false);
                }}
              >
                Logout
              </button>
            </li>
          </ul>
        </div>
      )}

      {/* Sidebar (Opens Only in Mobile) */}
      {isSidebarOpen && <Sidebar onClose={() => setIsSidebarOpen(false)} />}
      {upload && (
        <BulkUploadPopup
          onClose={() => setUpload(false)}
          setRefresh={setRefresh}

        />
      )}
      <AddCase isOpen={isModalOpen} onClose={closeModal} refresh={setRefresh} />
    </div>
  );
};

export default Navbar;